import React, { useCallback, useEffect, useState } from 'react';
import DataTableNativeML from '@/components/DataTableNativeML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import { CAMPAIGNTYPE, OPERATESTATUS } from '@/constants';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { history, useIntl } from 'umi';
import ResultListStyled from './ResultListStyled';
import { useSelector, useDispatch } from 'dva';
import webStorage from '@/utils/storageManager';

const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const theme = useTheme();
  const { pageData } = props;
  const { handlePageChange } = props;
  const [refreshPage, setRefreshPage] = useState(false);
  const loadingEffect = useSelector((state) => state.loading);
  const listLoading = loadingEffect.effects['operateList/getOperateList'];
  const userAuths = webStorage.get('USER')?.authorities;
  const buttonsAuth = [
    'MENU_MARKETING_CROWD_DETAIL',
    'MENU_MARKETING_CROWD_ASSIGN_TELEPHONE',
    'MENU_MARKETING_CROWD_CUSTOM_CROWD',
    'MENU_MARKETING_CROWD_KEY_RECALL',
    'MENU_MARKETING_CROWD_REGISTERED_UNPAID',
  ];
  const filterAuth = buttonsAuth.filter((i) => userAuths.includes(i)) || [];
  const onlyDetail =
    filterAuth.length === 1 && filterAuth[0] === 'MENU_MARKETING_CROWD_DETAIL';
  const { data: operateList, total } =
    useSelector((state) => state.operateList?.operateList) || {};
  //运营列表,只为刷新列表使用
  const fetchCouponList = useCallback(() => {
    if (refreshPage) {
      dispatch({
        type: 'operateList/getOperateList',
        payload: {
          values: {
            pageNum: 1,
            pageSize: 10,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            setRefreshPage(false);
          }
        },
      });
    }
  }, [dispatch, refreshPage]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  //处理活动暂停
  const handleClickPause = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'operateList/activityGroupPause',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          console.log('res', res);
          if (res.code === 0) {
            setRefreshPage(true);
            window.message.toast({
              type: 'success',
              message: '暂停成功',
              title: '成功',
            });
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };

  //处理活动重启
  const handleClickRestart = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'operateList/activityGroupRestart',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          console.log('res', res);
          if (res.code === 0) {
            setRefreshPage(true);
            window.message.toast({
              type: 'success',
              message: '重启成功',
              title: '成功',
            });
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };

  //处理活动终止

  const handleClickTerminate = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'operateList/activityGroupTerminate',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          console.log('res', res);
          if (res.code === 0) {
            setRefreshPage(true);
            window.message.toast({
              type: 'success',
              message: '终止成功',
              title: '成功',
            });
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };
  //处理审核

  const handleClickApprove = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'operateList/activityGroupApprove',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          console.log('res', res);
          if (res.code === 0) {
            setRefreshPage(true);
            window.message.toast({
              type: 'success',
              message: '审核成功',
              title: '成功',
            });
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };
  const columns = [
    {
      align: 'center',
      title: formatMessage({ id: 'marketing.people.c01.lbl01' }),
      id: 'title',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      width: 220,
    },
    {
      title: formatMessage({ id: 'marketing.people.c01.lbl02' }),
      align: 'center',
      id: 'typeName',
      key: 'typeName',
      width: 120,
      render: ({ typeName }) => {
        return CAMPAIGNTYPE.find((i) => i.value === typeName)?.name;
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.c01.lbl03' }),
      id: 'beginTime',
      key: 'beginTime',
      width: 120,
      align: 'center',
      // render: ({ beginTim }) => {
      //   return dayjs(beginTim).format('yyyy/mm/dd hh:mm');
      // },
    },
    {
      title: formatMessage({ id: 'marketing.people.c01.lbl04' }),
      align: 'center',
      id: 'executeTypeName',
      key: 'executeTypeName',
      width: 100,
      render: ({ executeTypeName }) => {
        return executeTypeName === 'EXECUTE_IMMEDIATELY'
          ? '立即执行'
          : '定时执行';
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.c01.lbl05' }),
      align: 'center',
      id: 'statusName',
      key: 'statusName',
      width: 100,
      render: ({ statusName }) => {
        return OPERATESTATUS.find((i) => i.value === statusName)?.name;
      },
    },
    {
      title: formatMessage({ id: 'marketing.people.c01.lbl06' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 180,
      render: ({ id, typeName, statusName }) => {
        const canEdit =
          statusName === 'NOT_START' ||
          statusName === 'PAUSED' ||
          statusName === 'UNAPPROVED';
        const canPause =
          statusName === 'NOT_START' || statusName === 'UNDER_WAY';
        const canTerminate =
          statusName === 'NOT_START' ||
          statusName === 'PAUSED' ||
          statusName === 'UNDER_WAY';
        const canRestart = statusName === 'PAUSED';
        const canApproval = statusName === 'UNAPPROVED';
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_user_operation_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                className={!canEdit && 'no-drop'}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  !onlyDetail &&
                    canEdit &&
                    history.push({
                      pathname: `/marketing/crowd/${typeName.toLowerCase()}`,
                      query: {
                        cardType: typeName,
                        opt: 'edit',
                        id: String(id),
                        sourceOid:
                          'btn_marketing_activity_user_operation_list_edit',
                      },
                    });
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit && !onlyDetail
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={canEdit && 'canClick'}
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_user_operation_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  history.push({
                    pathname: `/marketing/crowd/${typeName.toLowerCase()}_detail`,
                    query: {
                      cardType: typeName,
                      opt: 'detail',
                      id,
                      sourceOid:
                        'btn_marketing_activity_user_operation_list_details',
                    },
                  });
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip
              title={
                statusName === 'PAUSED'
                  ? formatMessage({ id: 'comm.action.btn.18' })
                  : formatMessage({ id: 'comm.action.btn.10' })
              }
            >
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_user_operation_list_pause',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                className={!canPause && 'no-drop'}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (statusName === 'PAUSED') {
                    !onlyDetail &&
                      canRestart &&
                      handleClickRestart(id, 'restart');
                  } else {
                    !onlyDetail && canPause && handleClickPause(id, 'pause');
                  }
                }}
              >
                <SvgIconML
                  // name="stop"
                  name={statusName === 'PAUSED' ? 'restart' : 'pause'}
                  size={24}
                  fill={
                    (canPause || canRestart) && !onlyDetail
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={
                    (canPause || canRestart) && !onlyDetail ? 'canClick' : ''
                  }
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.11' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_user_operation_list_terminate',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                className={!canTerminate && 'no-drop'}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  !onlyDetail &&
                    canTerminate &&
                    handleClickTerminate(id, 'terminate');
                }}
                // onClick={() => handleMemberDetail(recor, 'detail')}
              >
                <SvgIconML
                  name="stop"
                  size={24}
                  fill={
                    !onlyDetail && canTerminate
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={canTerminate && 'canClick'}
                />
              </IconButton>
            </ButtonTip>
            {/* <IconButton
              className={!canRestart && 'no-drop'}
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"

              onClick={() => {
                canRestart && handleClickRestart(id, 'restart');
              }}
            >
              <SvgIconML
                name={'restart'}
                fill={canRestart ? theme.palette.primary.main :theme.palette.secondary.disabled}
                className={canRestart && 'canClick'}
                size={24}
              ></SvgIconML>
            </IconButton> */}
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.12' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_user_operation_list_review',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: id,
                  },
                })}
                className={!canApproval && 'no-drop'}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                // 审批
                onClick={() => {
                  !onlyDetail &&
                    canApproval &&
                    handleClickApprove(id, 'approve');
                }}
              >
                <SvgIconML
                  name={'approve'}
                  fill={
                    !onlyDetail && canApproval
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  size={24}
                  className={canApproval && 'canClick'}
                ></SvgIconML>
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  //关于操作按钮二次弹出确认框
  const [openDialog, setOpenDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const actionList = [
    {
      type: 'pause',
      dialogTitle: formatMessage({ id: 'comm.action.btn.10' }),
      dialogContent: formatMessage({ id: 'marketing.people.d01.txt01' }),
    },
    {
      type: 'terminate',
      dialogTitle: formatMessage({ id: 'comm.action.btn.11' }),
      dialogContent: formatMessage({ id: 'marketing.people.d03.txt01' }),
    },
    {
      type: 'restart',
      dialogTitle: formatMessage({ id: 'comm.action.btn.18' }),
      dialogContent: formatMessage({ id: 'marketing.people.d02.txt01' }),
    },
    {
      type: 'approve',
      dialogTitle: formatMessage({ id: 'comm.action.btn.12' }),
      dialogContent: formatMessage({ id: 'marketing.people.d04.txt01' }),
    },
  ];

  //换页
  const changePage = (obj) => {
    handlePageChange({ ...pageData, ...obj });
  };

  return (
    <ResultListStyled>
      <DataTableNativeML
        columns={columns}
        loading={listLoading}
        changePage={changePage}
        page={pageData}
        data={operateList}
        total={total}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
    </ResultListStyled>
  );
};
export default ResultList;
